import { Button, Col, Flex, Row } from 'antd';
import { TextS } from 'components/Text';
import { truncateString } from 'helpers/formaters';
import { IoMdCloseCircleOutline } from 'react-icons/io';
import { LuFileCheck2 } from 'react-icons/lu';
import { useTheme } from 'styled-components';

export interface IFileInfoProps {
	file: File;
	onRemove: () => void;
}

export const FileInfo = ({ file, onRemove }: IFileInfoProps) => {
	const theme = useTheme();

	return (
		<Col>
			<Flex style={{ flexDirection: 'column' }}>
				<Flex
					style={{
						minWidth: '100%',
						backgroundColor: theme.primaryOpacity,
						padding: '0 1rem',
						height: '2rem',
						borderRadius: '5px',
					}}
					align="center"
					justify="space-between"
				>
					<Flex align="center" gap={10}>
						<LuFileCheck2 color={theme.primary} size={18} />
						<TextS
							style={{
								color: theme.textGray,
								margin: '1rem 0',
							}}
						>
							{truncateString(file.name, 35)}
						</TextS>
						<TextS
							weight={300}
							style={{
								color: theme.textGray,
							}}
						>
							({(file.size / 1024).toFixed(2)}) KB
						</TextS>
					</Flex>
					<IoMdCloseCircleOutline
						onClick={onRemove}
						style={{ cursor: 'pointer' }}
						color={theme.primary}
						size={20}
					/>
				</Flex>
			</Flex>
			<Row style={{ marginBottom: '1rem' }}>
				<Flex style={{ width: '100%' }}>
					<Button
						onClick={onRemove}
						type="default"
						style={{
							width: '100%',
							border: 0,
							justifyContent: 'center',
							alignItems: 'center',
						}}
					>
						<TextS
							weight={600}
							style={{
								color: theme.primary,
							}}
						>
							Enviar outro arquivo
						</TextS>
					</Button>
				</Flex>
			</Row>
		</Col>
	);
};
